export default __webpack_public_path__ + "static/media/successMsg.415dcf3d.svg";